// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ckoS","footer":"ModalUpdate_footer__2N3v1"};